import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "organ-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search-form",
  style: {
    "margin-bottom": "15px"
  }
};
const _hoisted_4 = {
  class: "organ-list"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "image-slot"
};
const _hoisted_8 = {
  class: "operation-btns"
};
import { reactive, ref, markRaw, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getAllOrganListApi, deleteOrganByIdApi1, getOrganTagsApi, updateOrganByIdApi } from "@/service/modules/organ";
import { addLoading } from "@/utils/element-method";
import protoPagination from "@/components/proto-pagination.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
import UserBindDialog from "./components/user-bind-dialog.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'organ',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const organList = ref([]);
    const form = reactive({
      type: null,
      isRecommend: null,
      label: ""
    });
    let page = reactive({
      current: 1,
      size: 10
    });
    const total = ref(0);
    const organTags = ref([]);
    const imageViewerShow = ref(false);
    const imageViewerList = ref([]);
    const bindDialogVisible = ref(false);
    const currentOrganId = ref("");
    const currentOrganName = ref("");
    // 表格引用
    const tableRef = ref(null);
    onMounted(() => {
      getAllOrganList();
      getOrganTags();
    });
    function handleOrganAdd() {
      router.push("/organ/organ-add");
    }
    // getAllOrganList();
    async function getAllOrganList() {
      let instance = addLoading("organ-list");
      // let cPage = JSON.parse(JSON.stringify(page))
      // delete cPage.limit
      try {
        let res = await getAllOrganListApi({
          ...page,
          ...form
        });
        organList.value = res.data.data;
        total.value = res.data.total;
      } catch {} finally {
        instance.close();
      }
    }
    // 结构标签列表
    // getOrganTags();
    async function getOrganTags() {
      try {
        let res = await getOrganTagsApi();
        if (res.data.labels) {
          organTags.value = res.data.labels.split(",");
        }
      } catch {}
    }
    function handleOrganTableItem(item) {
      router.push({
        path: "/organ/organ-add",
        query: {
          id: item.id
        }
      });
    }
    // 取消/设为精选
    async function handleOrganRecommendItem(item) {
      console.log("item", item);
      let params = JSON.parse(JSON.stringify(item));
      if (params.isRecommend) {
        params.isRecommend = 0;
      } else {
        params.isRecommend = 1;
      }
      try {
        let res = await updateOrganByIdApi(item.id, params);
        ElMessage.success("操作成功");
        restList();
      } catch {}
    }
    function deleteOrganTableItem(id) {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          await deleteOrganByIdApi1(id);
          ElMessage.success("删除成功");
          restList();
        } catch {}
      }).catch(() => {});
    }
    function restList() {
      page.current = 1;
      getAllOrganList();
    }
    function handleOrganTableCurrentChange(val) {
      page.size = val;
      getAllOrganList();
    }
    function handleFullImg(item) {
      imageViewerShow.value = true;
      imageViewerList.value = [item.logoUrl];
    }
    function handleCloseImageViewer() {
      imageViewerShow.value = false;
      imageViewerList.value = [];
    }
    function handleOrganPerson(item) {
      currentOrganId.value = item.id;
      currentOrganName.value = item.name;
      bindDialogVisible.value = true;
    }
    function handleBindSuccess() {
      // ElMessage.success("机构人员绑定成功");
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createTextVNode(" 机构管理 ")), _createVNode(_component_el_button, {
        onClick: handleOrganAdd,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
        modelValue: form.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.type = $event),
        clearable: "",
        onClear: restList,
        onChange: restList,
        placeholder: "请选择机构类型",
        style: {
          "width": "200px",
          "margin-right": "15px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "医疗机构",
          value: 0
        }), _createVNode(_component_el_option, {
          label: "康复机构",
          value: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: form.isRecommend,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.isRecommend = $event),
        clearable: "",
        onClear: restList,
        onChange: restList,
        placeholder: "请选择是否精选",
        style: {
          "width": "200px",
          "margin-right": "15px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "否",
          value: 0
        }), _createVNode(_component_el_option, {
          label: "是",
          value: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createVNode(_component_el_select, {
        modelValue: form.label,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.label = $event),
        clearable: "",
        onClear: restList,
        onChange: restList,
        placeholder: "请选择机构标签",
        style: {
          "width": "200px",
          "margin-right": "15px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organTags.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item,
            value: item,
            key: index
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), [[_vShow, organTags.value.length]])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: organList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        style: {
          "width": "100%"
        }
      }, {
        empty: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          "min-width": "60"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (_unref(page).current - 1) * _unref(page).size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "机构名称",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "type",
          label: "机构类型",
          "min-width": "100",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [scope.row.type === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "医疗机构")) : _createCommentVNode("", true), scope.row.type === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "康复机构")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "机构封面",
          "min-width": "100"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_image, {
            onClick: $event => handleFullImg(scope.row),
            style: {
              "width": "50px",
              "height": "50px",
              "cursor": "pointer"
            },
            src: scope.row.logoUrl,
            fit: "cover"
          }, {
            error: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon)])]),
            _: 2
          }, 1032, ["onClick", "src"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "contactName",
          label: "联系人",
          "min-width": "100",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "机构电话",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "精选机构",
          "min-width": "80",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [scope.row.isRecommend ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "success"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("是")])),
            _: 1
          })) : _createCommentVNode("", true), !scope.row.isRecommend ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "error"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("否")])),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "min-width": "160",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "200",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleOrganPerson(scope.row),
            type: "primary"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("机构人员")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleOrganTableItem(scope.row),
            type: "primary"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleOrganRecommendItem(scope.row),
            type: "warning"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.isRecommend ? "取消精选" : "设为精选"), 1)]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => deleteOrganTableItem(scope.row.id)
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: _unref(page),
        total: total.value,
        onCurrentChange: handleOrganTableCurrentChange,
        onSizeChange: handleOrganTableCurrentChange
      }, null, 8, ["page", "total"])]), imageViewerShow.value ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        teleported: true,
        "url-list": imageViewerList.value,
        onClose: handleCloseImageViewer
      }, null, 8, ["url-list"])) : _createCommentVNode("", true), _createVNode(UserBindDialog, {
        dialogVisible: bindDialogVisible.value,
        "onUpdate:dialogVisible": _cache[3] || (_cache[3] = $event => bindDialogVisible.value = $event),
        organId: currentOrganId.value,
        organList: organList.value,
        onSuccess: handleBindSuccess
      }, null, 8, ["dialogVisible", "organId", "organList"])]);
    };
  }
});